import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { DynatraceService } from '@segurosvoluntarios_vel/commons-services';
import { catchError } from 'rxjs/operators';
import { CodigoError } from 'src/app/pago/models/CodigoErrorNegocio.model';
import { CustomError } from 'src/app/pago/models/CustomError.model';
import { ACCION_USUARIO } from 'src/app/pago/const/AccionUsuario.const';

@Injectable()
export class ErrorCatchingInterceptor implements HttpInterceptor {
  constructor(private dynatraceService: DynatraceService) {}

  private getErrorProperties(error: HttpErrorResponse): CustomError {
    const errorProperties: CustomError = {
      key: this.getAction(error.url),
      value: error.message,
      codeError: parseInt(CodigoError.ERROR_INDETERMINADO),
    };

    if (Array.isArray(error.error)) {
      const [serverError] = error.error;
      errorProperties.value = `${serverError?.codigo} - ${serverError?.mensaje}`;
      errorProperties.codeError = parseInt(CodigoError.ERROR_NEGOCIO);
    }

    return errorProperties;
  }

  private getAction(endPointUrl: string): string {
    if (endPointUrl.includes('maestros')) {
      return ACCION_USUARIO.maestros;
    }

    if (endPointUrl.includes('prismic')) {
      return ACCION_USUARIO.prismic;
    }

    const splitUrl = endPointUrl.split('/');
    const endpoint = splitUrl[splitUrl.length - 1];

    return ACCION_USUARIO[endpoint] || 'Indeterminada';
  }

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        const { key, value, codeError } = this.getErrorProperties(error);

        this.dynatraceService.reportCustomErrorWithAction(
          key,
          value,
          codeError
        );
        return throwError(() => error);
      })
    );
  }
}
